export default ({ request }) => ({
  ecomAmzFirstDemandDetailScmSummaryListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/scmSummaryList',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailScmPurchaseGenerateApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/scmPurchaseGenerate',
      method: 'POST',
      data,
    })
  },
})
